import { Localization } from 'src/app/shared/Localization';
import { AuthService } from 'src/app/auth/service/auth.service';
import { Router, ActivatedRoute, Params, NavigationEnd } from '@angular/router';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { EnclosuresService } from 'src/app/enclosures/services/enclosures.service';
import { HeaderService } from 'src/app/shared/services/header.service';
import {
  AppLanguage,
  LanguageService,
} from 'src/app/shared/services/language.service';
import {
  AppPageTexts,
  getAppTexts,
} from 'src/app/shared/i18n/app-text';

declare global {
  interface Window {
    FlutterChannel: any;
  }
}

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {
  readonly parkitLogo = 'assets/img/parkit-logo.png';
  idUser: any;
  intIDUsuario: number = 0;

  @Output() nameMenu = new EventEmitter<string>();

  public menuItems: any[];
  idProfile: number;
  idAdmin: any;
  nameProfile = '';
  public isCollapsed = true;
  greet = '';
  userName: any;
  error: any;
  onlyEnclosures: any = [];
  logo: any;
  style: any;
  styleIcon: any;
  state: any;
  isEvent: boolean;
  isPrepaid: boolean;
  showSidebar = true;
  showLangDialog = false;
  isSalesMenuExpanded = false;
  isSelectEnclosureActive = false;
  isMyTicketsActive = false;
  currentLang: AppLanguage = 'es';
  texts: AppPageTexts<'sidebar'> = getAppTexts('sidebar', 'es');
  private hasSetDefaultLogo = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthService,
    public readonly localization: Localization,
    private readonly enclosuresService: EnclosuresService,
    private readonly headerService: HeaderService,
    private readonly languageService: LanguageService
  ) {
    if (localStorage.getItem('idAdmin') == null) {
      this.authenticationService.currentUser.subscribe(
        (currentUser) =>
          (this.idAdmin =
            currentUser != null ? currentUser.response.intFKIDUsuario : 0)
      );
    } else {
      this.idAdmin = Number(localStorage.getItem('idAdmin'));
    }
    if (this.idAdmin !== 1) {
      localStorage.setItem('idAdmin', JSON.stringify(this.idAdmin));
    }
    this.authenticationService.currentUser.subscribe(
      (currentUser) =>
        (this.userName =
          currentUser != null ? currentUser.response.chrNombreUsuario : '')
    );
  }

  ngOnInit(): void {
    this.languageService.currentLang$.subscribe((language) => {
      this.currentLang = language;
      this.texts = getAppTexts('sidebar', language);
    });
    if (window.FlutterChannel) {
      window.FlutterChannel.postMessage('FlutterChannelPayment');
      this.showSidebar = false;
      return;
    }

    this.headerService.sidebarIcon$.subscribe((src) => {
      const s = src ? String(src).trim() : '';
      if (s && s.toUpperCase() !== 'N/A') {
        this.logo = s;
      } else {
        this.logo = 'assets/img/parkit-logo.png';
      }
    });

    this.authenticationService.currentUser.subscribe(
      (currentUser) =>
        (this.idUser =
          currentUser != null ? currentUser.response.intFKIDProfile : 0)
    );
    this.authenticationService.currentUser.subscribe(
      (currentUser) =>
        (this.intIDUsuario =
          currentUser != null ? Number(currentUser.response.intIDUsuario) : 0)
    );
    this.authenticationService.currentUser.subscribe(
      (currentUser) =>
        (this.idProfile =
          currentUser != null ? currentUser.response.intFKIDUsuario : 0)
    );
    this.authenticationService.currentUser.subscribe(
      (currentUser) =>
        (this.nameProfile =
          currentUser != null ? currentUser.response.chrNombreUsuario : '')
    );
    this.updateSalesMenuState(this.router.url);
    this.router.events.subscribe((event) => {
      if (!(event instanceof NavigationEnd)) return;
      this.isCollapsed = true;
      this.updateSalesMenuState(event.urlAfterRedirects);
    });
    this.checkHrs();
    this.listOnlyEnclosuresByAdmin();
  }

  listOnlyEnclosuresByAdmin(): void {
    if (this.idAdmin === 1) {
      this.style = '#031E3A';
      this.styleIcon = 'Parkit-icon';
      this.state = 'Monterrey, N.L.';
      this.logo = `assets/img/parkit-logo.png`;
    } else {
      const idAdmin = localStorage.getItem('idAdmin');
      const idRecinto = localStorage.getItem('idRecinto');
      this.enclosuresService.getEnclosureByAdminAndRecinto(idAdmin, idRecinto).subscribe(
        (data) => {
          const raw = data?.response ?? {};
          if (!raw || Object.keys(raw).length === 0) {
            this.style = '#031E3A';
            this.styleIcon = 'Parkit-icon';
            this.state = 'Monterrey, N.L.';
            this.logo = `assets/img/parkit-logo.png`;
            return;
          }
          const item: any = {
            ...raw,
            idAdmin: raw.intFKIdAdmin ?? raw.idAdmin,
          };
          this.idAdmin = item.idAdmin;
          localStorage.setItem('idAdmin', JSON.stringify(this.idAdmin));
          this.style = item.color;
          this.styleIcon = (item.nameAdmin || 'Parkit') + '-icon';
          const direction = (item.chrUbicacion || '').split(',');
          const location = direction.slice(direction.length - 2);
          this.state = location.length >= 2 ? location[0] + ', ' + location[1] : '';
          this.isEvent = item.isEvent;
          this.isPrepaid = item.isPrepaid;

          const rawIcon = item.photoIcon;
          const iconStr =
            rawIcon !== undefined && rawIcon !== null
              ? String(rawIcon).trim()
              : '';
          if (iconStr && iconStr.toUpperCase() !== 'N/A') {
            if (
              iconStr.startsWith('http://') ||
              iconStr.startsWith('https://') ||
              iconStr.startsWith('data:')
            ) {
              this.logo = iconStr;
            } else {
              this.logo =
                this.enclosuresService.buildFileExampleDownloadUrl(iconStr);
            }
          } else {
            this.logo = 'assets/img/parkit-logo.png';
          }
        },
        (error) => {
          this.error = error;
          this.style = '#031E3A';
          this.styleIcon = 'Parkit-icon';
          this.state = 'Monterrey, N.L.';
          this.logo = `assets/img/parkit-logo.png`;
        }
      );
    }
  }

  onLogoError(event: Event): void {
    if (this.hasSetDefaultLogo) return;
    const img = event?.target as HTMLImageElement | null;
    const fallback = 'assets/img/parkit-logo.png';
    if (img && img.src !== fallback) {
      img.src = fallback;
    }
    this.logo = fallback;
    this.hasSetDefaultLogo = true;
  }

  checkHrs(): void {
    const myDate = new Date();
    const hrs = myDate.getHours();
    if (hrs < 12) {
      this.greet = this.localization.goodMorning;
    } else if (hrs >= 12 && hrs <= 17) {
      this.greet = this.localization.goodAfternoon;
    } else if (hrs >= 17 && hrs <= 24) {
      this.greet = this.localization.goodEvening;
    }
  }

  onHome(): void {
    this.router.navigate(['/']);
  }

  closeLogout(): void {
    this.authenticationService.logout();
    this.router.navigate(['/login']);
    localStorage.clear();
  }

  routerName(name: string): void {
    const nameDefault = this.texts.home;
    const nameSelectEnclosure = this.texts.selectEnclosure;
    if (name === nameSelectEnclosure) {
      localStorage.removeItem('salesUserAllInOne');
      localStorage.removeItem('salesUserAllInOneRecinto');
      localStorage.removeItem('salesUserAllInOneService');
    }
    if (name === nameDefault) {
      this.onHome();
    }
    this.nameMenu.emit(name);
  }

  toggleSalesMenu(): void {
    this.isSalesMenuExpanded = !this.isSalesMenuExpanded;
  }

  private updateSalesMenuState(url: string): void {
    const selectEnclosureRoutes = [
      '/locality',
      '/enclosure-by-locality',
      '/sales-user',
    ];
    this.isSelectEnclosureActive = selectEnclosureRoutes.some((route) =>
      url === route || url.startsWith(`${route}/`) || url.startsWith(`${route}?`)
    );
    this.isMyTicketsActive =
      url === '/buying-tickets' ||
      url.startsWith('/buying-tickets/') ||
      url.startsWith('/buying-tickets?');
    this.isSalesMenuExpanded =
      this.isSelectEnclosureActive || this.isMyTicketsActive;
  }

  selectLang(code: AppLanguage): void {
    this.languageService.setLanguage(code);
    this.showLangDialog = false;
  }

  password(): void {
    this.router.navigate(['/change-pass']);
  }

  profile(): void {
    this.router.navigate(['/change-profile']);
  }
}
